<p-confirmDialog
  key="publishDialog"
  #cd
  styleClass="w-9"
  appendTo="body"
  [blockScroll]="false">
  <ng-template pTemplate="headless" let-message>
    <div class="p-card border-round pt-1 p-4">
      <app-header
        icon="fas fa-earth-europe"
        text="Daten veröffentlichen"></app-header>

      <p>
        Sollen die Daten zum Indikator
        <i>„{{ indicatorStore.getFullName(indicator, false) }}“</i> für „<i>{{
          dataLayerType.name
        }}</i
        >“ und das Jahr <i>{{ dataLayer.year }}</i
        >, wirklich veröffentlicht werden?
      </p>

      <p>
        Nach der Veröffentlichung sind die Daten im öffentlichen Atlas für
        <u>alle</u>
        sichtbar.
      </p>

      @if (!dataLayer.published) {
        <div class="flex">
          <p-scrollPanel styleClass="h-20rem w-full">
            <app-alert
              styleClass="p-3 pt-1 "
              icon="fas fa-circle-info"
              header="Veröffentlichung nicht möglich"
              [canToggle]="false">
              <p>
                Die Daten können aktuell <u>nicht</u> im öffentlichen Atlas
                angezeigt werden, da das Jahr <i>{{ dataLayer.year }}</i> noch
                nicht veröffentlicht ist.
              </p>

              <p-divider></p-divider>

              <p-checkbox
                [(ngModel)]="publishDataLayerId"
                [binary]="true"
                [label]="
                  'Jahr ' + dataLayer.year + ' jetzt ebenfalls veröffentlichen'
                "></p-checkbox>

              @if (
                publishDataLayerId &&
                  dataStore.publishedByDataLayer(dataLayer._id);
                as publishedData
              ) {
                @if (publishedData.length) {
                  <p-divider></p-divider>
                  Dadurch werden auch folgende Daten öffentlich sichtbar sein:

                  <div class="flex gap-3 py-3">
                    @for (dataItem of publishedData; track $index) {
                      @if (
                        indicatorStore.getById(dataItem.indicator);
                        as indicator
                      ) {
                        <p-chip
                          styleClass="bg-primary"
                          [label]="indicatorStore.getFullName(indicator, false)"
                          [icon]="
                            indicator.parent
                              ? 'fas fa-ruler-combined'
                              : 'fas fa-ruler-vertical'
                          ">
                        </p-chip>
                      }
                    }
                  </div>
                }
              }
            </app-alert>
          </p-scrollPanel>
        </div>
      }

      <div class="flex align-items-center gap-3 mt-4">
        <button
          [rounded]="true"
          [outlined]="true"
          severity="secondary"
          pButton
          icon="fas fa-times"
          label="nein, abbrechen"
          (click)="cd.reject()"></button>
        <button
          [rounded]="true"
          pButton
          [severity]="'info'"
          icon="fas fa-check"
          label="ja, veröffentlichen"
          (click)="cd.accept()"
          class="ml-auto"></button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
